import { render } from "./DeletedApplicationsList.vue?vue&type=template&id=ca818a7a"
import script from "./DeletedApplicationsList.vue?vue&type=script&lang=js"
export * from "./DeletedApplicationsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__